import NewDashboard from '@features/todos/screens/NewDashboard'
import NewManager from '@features/todos/screens/NewManager'
import TodosView from '@features/todos/screens/TodosView'
import { Route } from 'react-router-dom'

const INDEX = 'todos'
const DASHBOARD = 'dashboard'
const MANAGE = 'manage'

export const TODOS = {
  INDEX: `/${INDEX}`,
  DASHBOARD: `/${INDEX}/${DASHBOARD}`
}

export const todosRoutes = (
  <Route path={INDEX} element={<TodosView />}>
    <Route path={DASHBOARD} element={<NewDashboard />} />
    <Route path={MANAGE} element={<NewManager />} />
  </Route>
)

export default todosRoutes
